import { render, staticRenderFns } from "./SubfolderArchive.vue?vue&type=template&id=ff70f252"
import script from "./SubfolderArchive.vue?vue&type=script&lang=js"
export * from "./SubfolderArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports